var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberLinkIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    rx: 15.5,
    fill: "#979797",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9.35858C7.75 8.81985 7.93546 8.37541 8.30638 8.02525C8.67729 7.67508 9.15949 7.5 9.75296 7.5C10.3358 7.5 10.8074 7.67238 11.1677 8.01717C11.5387 8.37273 11.7241 8.83601 11.7241 9.40707C11.7241 9.92424 11.544 10.3552 11.1836 10.7C10.8127 11.0555 10.3252 11.2333 9.72116 11.2333H9.70527C9.12239 11.2333 8.65081 11.0555 8.29048 10.7C7.93015 10.3444 7.75 9.8973 7.75 9.35858ZM7.95665 23.5V12.704H11.4857V23.5H7.95665ZM13.4409 23.5H16.97V17.4717C16.97 17.0946 17.0124 16.8037 17.0971 16.599C17.2455 16.2326 17.4707 15.9229 17.7727 15.6697C18.0748 15.4165 18.4536 15.2899 18.9093 15.2899C20.0963 15.2899 20.6897 16.1033 20.6897 17.7303V23.5H24.2187V17.3101C24.2187 15.7155 23.8478 14.506 23.106 13.6818C22.3642 12.8576 21.3839 12.4454 20.1651 12.4454C18.7981 12.4454 17.733 13.0434 16.97 14.2394V14.2717H16.9541L16.97 14.2394V12.704H13.4409C13.4621 13.0488 13.4727 14.1209 13.4727 15.9202C13.4727 17.7195 13.4621 20.2461 13.4409 23.5Z",
    fill: "#EEEEEE",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberLinkIn);
export default __webpack_public_path__ + "static/media/member-link-in.d44151b15ed6c21e58e5c82353778073.svg";
export { ForwardRef as ReactComponent };